<div class="home-container">
  <!-- <a class="btn-down-next-section" mat-mini-fab href="#nosotros"><mat-icon>keyboard_arrow_down</mat-icon></a> -->
  <app-carousel [items]="carouselData"></app-carousel>
</div>
